import {Component, OnInit} from "@angular/core";
import {BlogItem} from "./blog.component";
import {Router} from "@angular/router";
import {WSResponse} from "../portfolio/portfolio.datatypes";
import {BlogService} from "../blog.service";
import {HttpErrorResponse} from "@angular/common/http";
import {DatePipe} from "@angular/common";

@Component({
    selector: 'blog-home',
    templateUrl: './blog-home.component.html'
})

export class BlogHomeComponent implements OnInit {
    blogItems: BlogItem[];
    errorMsg: string;

    constructor(
        private router: Router,
        private blogService: BlogService,
        private datePipe: DatePipe) {
    }

    ngOnInit() {
        this.getBlog();
    }

    private getBlog() {
        let serverResponse: WSResponse;
        this.blogService.getBlogList()
            .subscribe(
                (data) => {
                    serverResponse = data;
                    if (serverResponse.success === false) {
                        this.errorMsg = serverResponse.message;
                    }

                },
                (error: HttpErrorResponse) => {
                    this.errorMsg = error.message;
                },
                () => {
                    if (serverResponse.success) {
                        this.blogItems = serverResponse.message;
                        this.blogItems.forEach((item) => {
                            item.postDate = item.postDate.replace(' ', 'T');
                        })
                    }
                }
            )
    }

    showItem($event: Event, slug: string) {
        $event.preventDefault();
        this.router.navigate(['/blog', slug]);
    }
}


// WEBPACK FOOTER //
// ./src/app/blog/blog-home.component.ts